import { html, ref, when, repeat } from '@microsoft/fast-element';
import { sync } from '@genesislcap/foundation-utils';
import type { MarketInfoTab } from './market-info-tab';
import { PROJECT_OPERATIONAL_STATUS } from '../../../../../utils/enums/generic.enum';
import { infoIcon } from '../../../../../styles';

export const MarketInfoTabTemplate = html<MarketInfoTab>`
  <div class="form-control required">
    <label>ISO</label>
    <zero-select
      ${ref('iso')}
      :value=${sync((x) => x.isoValue)}
      class="input-control"
      @change="${(x) => x.isoSelected()}"
    >
      <zero-option value="">Select ISO</zero-option>
      ${repeat(
        (x) => x._ISO,
        html`
          <zero-option value="${(x) => x}">${(x) => x}</zero-option>
        `,
      )}
    </zero-select>
  </div>

  <div class="form-control required">
    <label>
      Interconnection Region
      <info-icon id="interconnectionRegionTooltip"></info-icon>
    </label>
    <zero-select
      ${ref('settlementPoint')}
      id="interconnectionRegion"
      :value=${sync((x) => x.settlementPointValue)}
      class="input-control"
      ?disabled="${(x) => !x.iso.value}"
    >
      <zero-option value="">Select Interconnection Region</zero-option>
      ${repeat(
        (x) => x._settlementPoints,
        html`
          <zero-option value="${(x) => x}">${(x) => x}</zero-option>
        `,
      )}
    </zero-select>
    <zero-tooltip anchor="interconnectionRegionTooltip" position="top">
      Select the physical hub in which your project’s interconnection point sits, used in estimating
      physical carbon impact
    </zero-tooltip>
  </div>

  <div class="form-control required">
    <auto-fill-input
      ${ref('interPoint')}
      header="Interconnection Point"
      :dataArray=${(x) => x._interPoints}
      :required=${true}
    ></auto-fill-input>
  </div>

  <div class="form-control required">
    <label>Interconnection Voltage</label>
    <zero-select
      ${ref('interVoltage')}
      :value=${sync((x) => x.interVoltageValue)}
      class="input-control"
    >
      ${repeat(
        (x) => x.interconnectionVoltageEnum,
        html`
          <zero-option value="${(x) => x.ENUM_VALUE}">${(x) => x.READABLE_VALUE}</zero-option>
        `,
      )}
    </zero-select>
  </div>

  <zero-text-field
    ${ref('interUtility')}
    :value=${sync((x) => x.interUtilityValue)}
    class="input-control"
    type="text"
    placeholder="Enter..."
    required
  >
    Interconnecting Utility
  </zero-text-field>

  <div
    class="form-control date long-error required"
    style="display: ${(x) =>
      x.projectOperationalStatus === PROJECT_OPERATIONAL_STATUS.OPERATIONAL ? 'none' : ''}"
  >
    <label>Target COD</label>
    <zero-text-field
      ${ref('targetCOD')}
      class="input-control"
      type="date"
      placeholder="Enter..."
      onkeydown="return false"
      :value=${sync((x) => x.targetCODValue)}
    ></zero-text-field>
  </div>

  <div
    class="form-control date long-error required"
    style="display: ${(x) =>
      x.projectOperationalStatus === PROJECT_OPERATIONAL_STATUS.OPERATIONAL ? 'none' : ''}"
  >
    <label>Guaranteed COD</label>
    <zero-text-field
      ${ref('guarantedCOD')}
      :value=${sync((x) => x.guarantedCODValue)}
      placeholder="Enter..."
      type="date"
      onkeydown="return false"
    ></zero-text-field>
  </div>

  <div
    class="form-control date long-error required"
    style="display: ${(x) =>
      x.projectOperationalStatus === PROJECT_OPERATIONAL_STATUS.OPERATIONAL ? '' : 'none'}"
  >
    <label>COD</label>
    <zero-text-field
      ${ref('operationalProjectCOD')}
      :value=${sync((x) => x.operationalProjectCODValue)}
      placeholder="Enter..."
      type="date"
      onkeydown="return false"
    ></zero-text-field>
  </div>

  <zero-text-field
    ${ref('interQueueId')}
    :value=${sync((x) => x.interQueueIdValue)}
    class="input-control"
    type="text"
    placeholder="Enter..."
    style="display: ${(x) =>
      x.projectOperationalStatus === PROJECT_OPERATIONAL_STATUS.OPERATIONAL ? 'none' : ''}"
  >
    Interconnection Queue ID
  </zero-text-field>
`;
